import { Injectable, inject } from '@angular/core';
import { catchError, EMPTY } from 'rxjs';

import { ApiMethod } from '@app/interfaces/api-request-body.interface';
import { JsonRpcService } from '@app/services/json-rpc.service';
import { LoadingService } from '@app/services/loading.service';
import { ToastService } from '@app/services/toast.service';

const langMap: Record<string, string> = {
  de: 'D',
  it: 'I',
  fr: 'F',
};

@Injectable({
  providedIn: 'root',
})
export class MessageTemplateService {
  private toastSrv = inject(ToastService);
  private jsonrpc = inject(JsonRpcService);
  private loadingSrv = inject(LoadingService);

  getMessageTemplate(language = 'D', gender = 'N', vip_family = 0) {
    language = langMap[language] || language;
    return this.loadingSrv
      .runWithLoading(
        this.jsonrpc.request<{
          GREETING: string;
          ENDING: string;
        }>(ApiMethod.getMessageTemplate, {
          language,
          gender,
          vip_family,
        }),
      )
      .pipe(
        catchError((error) => {
          console.log('error getting message template', error);
          this.toastSrv.showToast("Sorry, we didn't find template for this contact.");
          return EMPTY;
        }),
      );
  }
}
